import { render, staticRenderFns } from "./ReservationColumnGroupsTab.vue?vue&type=template&id=44007943&scoped=true&"
import script from "./ReservationColumnGroupsTab.vue?vue&type=script&lang=js&"
export * from "./ReservationColumnGroupsTab.vue?vue&type=script&lang=js&"
import style0 from "./ReservationColumnGroupsTab.vue?vue&type=style&index=0&id=44007943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44007943",
  null
  
)

export default component.exports